import React from 'react';
import { Skeleton } from 'antd';

export const LoadingTopicTest = () => (
  <div className="mx-auto my-7 min-h-screen max-w-[1150px] p-4">
    <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-4">
      <div className=" space-y-3 self-start md:sticky md:top-4">
        <div className="shadow-xs rounded-xl bg-white p-3">
          <Skeleton.Input className="!h-50 !w-full" active />
        </div>
        <div className="shadow-xs rounded-xl bg-white p-3">
          <Skeleton.Input className="!h-30 !w-full" active />
        </div>
      </div>
      <div className="sm:col-span-3">
        <div className="shadow-xs mb-3 rounded-xl bg-white px-4 py-3">
          <div className="mb-5 flex items-center justify-between">
            <Skeleton.Button active className="!h-2" />
            <Skeleton.Input active className="!h-2" />
          </div>
          <Skeleton active />
        </div>
        <div className="shadow-xs mb-4 rounded-xl bg-white px-4 py-3">
          <div className="space-y-3">
            <Skeleton.Input active className="!h-12 !w-full !rounded-xl" />
            <Skeleton.Input active className="!h-12 !w-full !rounded-xl" />
            <Skeleton.Input active className="!h-12 !w-full !rounded-xl" />
            <Skeleton.Input active className="!h-12 !w-full !rounded-xl" />
            <div className="mt-5 flex items-center justify-between">
              <Skeleton.Button active className="!w-30 !h-10 !rounded-lg" />
              <Skeleton.Button active className="!w-35 !h-10 !rounded-lg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
